import Storage from 'lib/utils/localStorage';

const currentTimezone = () => (Storage.getParam('facility/timezone') ?? 'US/Central').trim();

export default currentTimezone;
